import { projectName } from '@/config';

const getSavedState = key => JSON.parse(localStorage.getItem(`${projectName}.${key}`));

const saveState = (key, state) => {
    window.localStorage.setItem(`${projectName}.${key}`, JSON.stringify(state));
    window.dispatchEvent(new Event('storage'));
};

const getLoggedUser = () => {
    const user = getSavedState('auth.currentUser');

    return user || null;
};

const removeSavedState = key => {
    window.localStorage.removeItem(`${projectName}.${key}`);
};

export { getSavedState, saveState, getLoggedUser, removeSavedState };
